import axios from 'axios';

/**
 * Axios instance for public, unauthenticated endpoints.
 *
 * Deliberately separate from apiClient: apiClient attaches a token to every
 * request and forces a logout + redirect to /login on any 401. Public pages
 * such as account deletion must work for signed-out visitors, so they cannot
 * go through that interceptor.
 */
const baseURL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const publicClient = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json' },
});

export default publicClient;
